import { render, staticRenderFns } from "./FaxNumber.vue?vue&type=template&id=024d4d8e&"
import script from "./FaxNumber.vue?vue&type=script&lang=js&"
export * from "./FaxNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports